export default __webpack_public_path__ + "static/media/signupsuccess.1b8dea66.png";